const trackEventData = {
    productId: '',
    productName: '',
    productType: '',
    productVendor: '',
    variantId: '',
    variantName: '',
    price: 0,
    quantity: 1,
};

document.addEventListener('DOMContentLoaded', function() {
    const buyBoxOneTime                             = document.querySelector('#ProductSubscriptionLayout .product-subscription-layout-one-time');
    const buyBoxSubscribeSelectors                  = Array.from(document.querySelectorAll('#ProductSubscriptionLayout .product-subscription-layout-subscribe .product-subscription-layout-sub-bottle'));
    const buyBoxOneTimeSelectors                    = Array.from(document.querySelectorAll('#ProductSubscriptionLayout .product-subscription-layout-one-time .product-subscription-layout-sub-bottle'));
    const buyBoxSelectors                           = Array.from(document.querySelectorAll('#ProductSubscriptionLayout [name="[buy-box-button]"]'));
    const buyBoxAtcButton                           = document.querySelector('.subscription-bundles #ProductSubscriptionLayout .product-subscription-layout__btn button');
    const saveMessages                              = document.querySelectorAll('[data-dinamic-save-percentage]');
    const benefitMessage                            = document.querySelector('[data-dinamic-days-benefit]');

    if ((!!!buyBoxAtcButton) || buyBoxSubscribeSelectors.length === 0 || buyBoxOneTimeSelectors.length === 0 || buyBoxSelectors.length === 0) return;

    buyBoxSubscribeSelectors.forEach((subscribeSelector) => {
        subscribeSelector.addEventListener('click', handleSubscribeClick);
        subscribeSelector.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); subscribeSelector.click(); }
        });
    });

    buyBoxOneTimeSelectors.forEach((oneTimeSelector) => {
        oneTimeSelector.addEventListener('click', handleOneTimeClick);
        oneTimeSelector.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); oneTimeSelector.click(); }
        });
    });

    buyBoxSelectors.forEach((buyBoxSelector) => buyBoxSelector.addEventListener('click', handleBuyBoxSelector))

    buyBoxAtcButton && buyBoxAtcButton.addEventListener('click', handleAddToCart);

    const defaultActiveBox = buyBoxSubscribeSelectors?.find(x => x.classList.contains('active'))
    if (defaultActiveBox) buildTrackEventData(defaultActiveBox);

    function handleSubscribeClick(evt) {
        const elementTarget = evt.target.closest('.product-subscription-layout-sub-bottle');
        switchActiveClasses(buyBoxSubscribeSelectors, elementTarget);
        atcButtonPrice(elementTarget.dataset.priceTotal, elementTarget.dataset.priceTotalCompared, true);
        updateSaveMessages(elementTarget.dataset.save);
        updateBenefitMessage(elementTarget.dataset.benefitMessage);
        buildTrackEventData(elementTarget);
    }

    function updateSaveMessages(save) {
        const saveBenefit = document.querySelector('[data-dinamic-save-benefit]');
        if (saveBenefit) saveBenefit.innerHTML = `<p><strong>Save ${ save } on every order</strong></p>`;
        if(!!!saveMessages) return;
        saveMessages?.forEach((saveMessage, index) => {
            if (index === 0) {
                saveMessage.innerHTML = `Save ${ save }`;
                return
            }
            saveMessage.innerHTML = `${ save }`;
        })
    }

    function updateBenefitMessage(benefit) {
        if(!!!benefitMessage) return;
        benefitMessage.innerHTML = `<p><strong>${ benefit }</strong></p>`;
    }

    function trackIntelligemsEvent(event) {
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
            event: event,
        });
    }

    function handleOneTimeClick(evt) {
        const elementTarget = evt.target.closest('.product-subscription-layout-sub-bottle');
        if (elementTarget && Number(elementTarget.dataset.dtcQuanty) >= 2) {
            trackIntelligemsEvent("Cart Discount Banner Displayed")
        }
        switchActiveClasses(buyBoxOneTimeSelectors, elementTarget);
        atcButtonPrice(elementTarget.dataset.priceTotal, elementTarget.dataset.priceTotalCompared);
        buildTrackEventData(elementTarget);
    }

    function handleBuyBoxSelector(evt) {
        const elementTarget = evt.target.closest('[name="[buy-box-button]"]');
        if (elementTarget.id === 'buy-box-subscribe') {
            const currentSelected = buyBoxSubscribeSelectors.find((element) => element.classList.contains('active'));
            if (!!!currentSelected) return
            
            currentSelected.dispatchEvent(new Event('click'));
            return
        }

        const currentSelected = buyBoxOneTimeSelectors.find((element) => element.classList.contains('active'));
        if (!!!currentSelected) return
        
        currentSelected.dispatchEvent(new Event('click'));
    }

    async function getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        return res.json();
    }

    async function changeLineByKey(key, quantity, selling_plan) {
        const payload = { id: key, quantity: Number(quantity) };
        if (selling_plan) payload.selling_plan = Number(selling_plan);

        const r = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        });
        return r.json();
    }

    function getPlanIdForQtyFromDOM(qty) {
        const pick = (needle) => {
            const el = buyBoxSubscribeSelectors.find(node => {
            const name = (node.dataset.planName || node.dataset.benefitMessage || node.textContent || '').toLowerCase();
            return name.includes(needle);
            });
            return el ? Number(el.dataset.sellingPlan) : null;
        };

        if (qty >= 6)  return pick('180') || pick('180 days') || pick('180d');
        if (qty >= 3)  return pick('90')  || pick('90 days')  || pick('90d');
        if (qty >= 1)  return pick('30')  || pick('30 days')  || pick('30d');
        return null;
    }

    async function addItems(items) {
        const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
        });
        return r.json();
    }

    async function handleAddToCart() {
        try {
            const isOneTime = isVisible(buyBoxOneTime);

            const currentSelected = (isOneTime ? buyBoxOneTimeSelectors : buyBoxSubscribeSelectors).find(el => el.classList.contains('active'));
            if (!currentSelected) return;

            const variantId = Number(currentSelected.dataset.variantId);
            const qtyToAdd = Number(currentSelected.dataset.dtcQuanty) || 1;
            const sellingPlan = isOneTime ? null : Number(currentSelected.dataset.sellingPlan);

            const cart = await getCart();

            const sameVariantLines = (cart.items || []).filter(i => i.variant_id === variantId);
            const lineOneTime = sameVariantLines.find(i => !i.selling_plan_allocation);
            const lineSub = sameVariantLines.find(i => !!i.selling_plan_allocation);

            await upsertLine({
                existingLine: isOneTime ? lineOneTime : lineSub,
                variantId,
                qtyToAdd,
                sellingPlan: isOneTime ? null : sellingPlan
            });

            if (typeof trackAddToCartEvent === 'function') trackAddToCartEvent();
            window.location.href = '/cart';
        } catch (err) {
            console.error('ATC merge error:', err);
        }
    }

    async function upsertLine({ existingLine, variantId, qtyToAdd, sellingPlan }) {
        const isSub = !!sellingPlan;

        if (existingLine) {
            if (isSub) {
                const totalQty = Number(existingLine.quantity || 0) + Number(qtyToAdd);
                const currentPlanId = Number(existingLine.selling_plan_allocation?.selling_plan?.id || 0);
                const desiredPlanId = Number(getPlanIdForQtyFromDOM(totalQty) || currentPlanId);

                if (desiredPlanId === currentPlanId || !desiredPlanId) {
                    return changeLineByKey(existingLine.key, totalQty, Number.isFinite(currentPlanId) && currentPlanId ? currentPlanId : undefined);
                }

                return changeLineByKey(existingLine.key, totalQty, desiredPlanId);
            }

            const newQty = Number((existingLine.quantity || 0) + Number(qtyToAdd));
            return changeLineByKey(existingLine.key, newQty, null);
        }

        const item = { id: Number(variantId), quantity: Number(qtyToAdd) };
        if (isSub) item.selling_plan = Number(sellingPlan);
        return addItems([item]);
    }

    const addToCart = (body) => {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        .then((response) => response.json())
        .then((data) => {
            trackAddToCartEvent();
            window.location.href = '/cart';
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    function atcButtonPrice(newPrice, newPriceCompared) {
        if (buyBoxAtcButton) buyBoxAtcButton.innerHTML = 'ADD TO CART';
    }

    function switchActiveClasses(elements, target) {
        elements.forEach((element) => {
            element.classList.remove('active');
            element.setAttribute('aria-checked', 'false');
        });
        target.classList.add('active');
        target.setAttribute('aria-checked', 'true');
        buildTrackEventData(target);
    }

    function isVisible(element) {
        const elementStyles = window.getComputedStyle(element, null);
        const displayValue = elementStyles.getPropertyValue('display');

        if (displayValue === 'none') return false;

        return true;
    }
});

const BUY_BOX_SELECTORS = {
    BUNDLE_BUY_BOX: 'BundleBuyBox-',
    INPUTS_BUY_BOX: 'buy-box',
    ADD_TO_CART_BUTTON: '.product-subscription-layout__btn button',
    ATC_PRICE_FINAL: 'span.text-price',
    ATC_PRICE_COMPARED: 'span.text-price-compared',
    INPUT_SUBSCRIBE: 'input#buy-box-subscribe'
}

class BundleBuyBox extends HTMLElement {
    constructor() {
        super();
        this.BundleBuyBox = this.querySelector(`[id^=${BUY_BOX_SELECTORS.BUNDLE_BUY_BOX}]`);
        this.buyBoxInputs = this.querySelectorAll(`input[name=${BUY_BOX_SELECTORS.INPUTS_BUY_BOX}]`);
        this.addToCartButton = this.querySelector(BUY_BOX_SELECTORS.ADD_TO_CART_BUTTON);
        this.buyBoxInputs.forEach(input => input.addEventListener('click', this.onButtonClick.bind(this)));
        this.addToCartButton && this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));

        const buyBoxes = Array.from(this.querySelectorAll('.product-bundle-buy-box__box'));
        buyBoxes.forEach((box) => {
            box.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this._selectBox(box);
                }
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    const next = buyBoxes[(buyBoxes.indexOf(box) + 1) % buyBoxes.length];
                    next.focus();
                }
                if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prev = buyBoxes[(buyBoxes.indexOf(box) - 1 + buyBoxes.length) % buyBoxes.length];
                    prev.focus();
                }
            });
            box.addEventListener('click', () => this._selectBox(box));
        });

        this._onPageShow = (e) => {
            const fromHistory = e.persisted || (performance.getEntriesByType('navigation')[0]?.type === 'back_forward');
            if (fromHistory) {
                requestAnimationFrame(() => this.ensureDefaultSubscribeSelected());
            }
        };
    }

    connectedCallback() {
        requestAnimationFrame(() => this.ensureDefaultSubscribeSelected());
        window.addEventListener('pageshow', this._onPageShow);
    }

    disconnectedCallback() {
        window.removeEventListener('pageshow', this._onPageShow);
    }

    _selectBox(box) {
        const radio = box.querySelector('input[type="radio"]');
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('click'));
        this._syncAriaChecked();
    }

    _syncAriaChecked() {
        this.querySelectorAll('.product-bundle-buy-box__box').forEach((box) => {
            const radio = box.querySelector('input[type="radio"]');
            box.setAttribute('aria-checked', radio && radio.checked ? 'true' : 'false');
        });
    }

    onButtonClick(evt) {
        const target = evt.target;
        this.updateAddToCartButton(target.dataset.priceTotal, target.dataset.comparedPriceTotal);
        this._syncAriaChecked();
    }

    handleAddToCart() {
        const input = this.querySelector(`input[name=${BUY_BOX_SELECTORS.INPUTS_BUY_BOX}]:checked`);
        if (!input) return;

        buildTrackEventData(input);

        const variantId = Number(input.dataset.variantId);
        const sellingPlanId = input.dataset.sellingPlanId ? Number(input.dataset.sellingPlanId) : null;
        const line = {
            id: variantId,
            quantity: 1,
            properties: { _bundle: true, _bundle_main: true }
        }

        if (sellingPlanId) line['selling_plan'] = sellingPlanId

        this.addToCart({ items: [ line ] });
    }

    async addToCart(body) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
        .then((response) => response.json())
        .then((data) => {
            trackAddToCartEvent();
            window.location.href = '/cart';
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    updateAddToCartButton(newPrice, newPriceCompared = undefined) {
        const priceFinal = this.addToCartButton.querySelector(BUY_BOX_SELECTORS.ATC_PRICE_FINAL);
        const priceCompare = this.addToCartButton.querySelector(BUY_BOX_SELECTORS.ATC_PRICE_COMPARED);
        priceFinal.innerText = newPrice;
        priceCompare.innerText = newPriceCompared ? newPriceCompared : '';
    }

    ensureDefaultSubscribeSelected() {
        const subscribe = this.querySelector(BUY_BOX_SELECTORS.INPUT_SUBSCRIBE);
        this.buyBoxInputs.forEach(input => { input.checked = false; });
        subscribe.checked = true;
        this.updateAddToCartButton(
            subscribe.dataset.priceTotal,
            subscribe.dataset.comparedPriceTotal
        );
        subscribe.dispatchEvent(new Event('change', { bubbles: true }));
        this._syncAriaChecked();
    }
}

customElements.define('bundle-buy-box', BundleBuyBox);

function trackAddToCartEvent() {
    console.info('Tracking Add to Cart Event', trackEventData);
    try {
        /* GA4 add_to_cart via GTM: top-level currency/value/items keys, matching the
           productPageVisit push shape (GTM variables read currency/value/items, not ecommerce.*) */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
            value: trackEventData.price,
            items: [{
                item_id: trackEventData.variantId,
                item_name: trackEventData.productName,
                item_category: trackEventData.productType,
                price: trackEventData.price,
                quantity: trackEventData.quantity
            }]
        });
    } catch (e) {
        console.warn('add_to_cart dataLayer push failed', e);
    }
    if (window.klaviyo) {
        klaviyo.push(['track', 'Added to Cart', {
            $value: trackEventData.price,
            AddedItemProductName: trackEventData.productName,
            AddedItemProductID: trackEventData.productId,
            AddedItemProductType: trackEventData.productType,
            AddedItemVariantID: trackEventData.variantId,
            AddedItemVariantName: trackEventData.variantName,
            AddedItemQuantity: trackEventData.quantity
        }]);
    }
}

function buildTrackEventData(elementTarget) {
    const dataPrice = parseFloat(elementTarget.dataset.priceTotal.replace('$', '')); // Example: data-price="$60.00" => 60.00
    const dataQuantity = Number(elementTarget.dataset.dtcQuanty); // Example: data-dtc-quanty="1" => 1
    const dataVariantId = elementTarget.dataset.variantId; // Example: data-variant-id="1234567890" => "1234567890"
    const dataProductId = elementTarget.dataset.productId; // Example: data-product-id="1234567890" => "1234567890"
    const dataProductTitle = elementTarget.dataset.productTitle; // Example: data-product-title="Product Name" => "Product Name"
    const dataProductType = elementTarget.dataset.productType; // Example: data-product-type="Product Type" => "Product Type"
    const dataProductVendor = elementTarget.dataset.productVendor; // Example: data-product-vendor="Vendor Name" => "Vendor Name"
    trackEventData.productId = dataProductId;
    trackEventData.productName = dataProductTitle;
    trackEventData.productType = dataProductType;
    trackEventData.productVendor = dataProductVendor;
    trackEventData.variantId = dataVariantId;
    trackEventData.variantName = dataProductTitle;
    trackEventData.price = dataPrice;
    trackEventData.quantity = dataQuantity;
}
